import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Spinner from "../ogComponent/spinner";
import { IconPlus } from "@tabler/icons-react";

export default function Departments() {
  const [departments, setDepartments] = useState([]);
  const [departmentCount, setDepartmentCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);

  const pagePermissions = ["showdepartmentsID", "adddepartmentsID"];

  useEffect(() => {
    // Only fetch departments if showdepartmentsID is in permissions
    if (permissions.includes("showdepartmentsID")) {
      const fetchDepartments = async () => {
        const token = localStorage.getItem("accessToken");
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API}/api/employee/departments/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setDepartments(response.data);
          setDepartmentCount(response.data.length);
        } catch (error) {
          console.error("Error fetching departments:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchDepartments();
    } else {
      setLoading(false); // Skip loading if no permission
    }
  }, [permissions]);

  const handleDepartmentClick = (id) => {
    navigate(`/user/department/${id}`);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="container-fluid px-3 px-md-4 d-flex flex-column gap-3">
      <div className="d-flex justify-content-center flex-column align-items-start mt-3 mb-1">
        {permissions.includes("showdepartmentsID") && (
          <div>
            <h5 className="fw-light mb-0">Departments</h5>
            <p
              className="align-self-start mb-2"
              style={{ color: "grey", fontSize: "clamp(10px, 1.1vw, 12px)", fontWeight: '600' }}
            >
              Total {departmentCount} Department{departmentCount !== 1 ? "s" : ""}
            </p>
          </div>
        )}
        {permissions.includes("adddepartmentsID") && (
          <Link
            to={'/user/functions?tabId=1'}
            className="btn btn-success d-flex justify-content-center align-items-center"
            style={{ height: '35px' }}
          >
            <IconPlus stroke={2} size={20} /> New Department
          </Link>
        )}
      </div>
      {permissions.includes("showdepartmentsID") ? (
        departmentCount === 0 ? (
          <div
            className="d-flex justify-content-center align-items-end position-relative"
            style={{ height: "50vh" }}
          >
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                backgroundImage: 'url(/assets/file.png)',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: 0.3,
              }}
            ></div>
            <p className="m-0 fw-light fs-5 position-relative">No Departments!</p>
          </div>
        ) : (
          <div className="row">
            {departments.map((department) => (
              <div
                key={department.id}
                className="col-12 col-sm-6 col-md-6 col-lg-4 mb-3"
                style={{ cursor: "pointer" }}
                onClick={() => handleDepartmentClick(department.id)}
              >
                <div className="card h-100 px-3 pb-2">
                  <div className="card-body d-flex flex-column py-1 px-0">
                    <div className="p-2">
                      <h6
                        className="card-title mb-0"
                        style={{
                          fontSize: 'clamp(12px, 1.2vw, 14px)',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          width: '100%'
                        }}
                        title={department.dep_name}
                      >
                        {department.dep_name}
                      </h6>
                    </div>
                    <div
                      className="rounded-3 px-3 py-2"
                      style={{ backgroundColor: "#f8f7f7", fontSize: 'clamp(12px, 1.2vw, 14px)' }}
                    >
                      <p className="card-text" style={{ marginBottom: '0.5rem' }}>
                        <i className="bi bi-person me-2"></i>
                        {department.dep_head}
                      </p>
                      <p className="card-text" style={{ marginBottom: '0.5rem' }}>
                        <i className="bi bi-telephone me-2"></i>
                        +91 {department.contact_info}
                      </p>
                      <p className="card-text" style={{ marginBottom: '0.5rem' }}>
                        <i className="bi bi-people me-2"></i>
                        Employees: {department.employee_count}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      ) : (
        <div
          className="d-flex justify-content-center align-items-end position-relative"
          style={{ height: "50vh" }}
        >
          <p className="m-0 fw-light fs-5 position-relative">No permission to view departments.</p>
        </div>
      )}
    </div>
  );
}